var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},[_c('div',{class:_vm.$style.headingContainer},[(_vm.logoPath)?_c('img',{class:_vm.$style.logo,attrs:{"src":_vm.logoPath}}):_vm._e(),_vm._v(" "),_c('span',{class:_vm.$style.title,domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_vm._t("heading")],2),_vm._v(" "),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }